<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <button v-on:click="logout">logout</button>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  methods: {
    logout: function() {
      firebase.auth().signOut();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
